<template>
    <div>
        <Spin fix v-show="isSpinShow">
            <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
            <div>Loading</div>
        </Spin>
        <Tabs value="name1">
            <TabPane label="阶梯气价" icon="md-trending-up" style="font-size:12pt" name="name1">

                <Table ref="selectionTable" :max-height="height" :data="showData" :columns="showColumns" stripe
                    highlight-row border @on-current-change="onSelectionTableChange"></Table>
                <Row style="padding:10px 0px 0px 0px">
                    <Col span=3 style="padding:0px 5px 0px 0px">
                    <Button long type="success" @click="onClickInsert">添加阶梯气价</Button>
                    </Col>
                    <Col span=3 style="padding:0px 5px 0px 0px">
                    <Button long type="warning" @click="onClickUpdate">修改所选阶梯气价</Button>
                    </Col>
                    <Col span=3 style="padding:0px 5px 0px 0px">
                    <Button long type="error" @click="onClickDelete">删除所选阶梯气价</Button>
                    </Col>
                    <Col span=15>
                    <Page :current="currentPage" :total="dataCount" :page-size="pageSize" show-sizer show-total
                        @on-change="changePage" @on-page-size-change="changePageSize" style="text-align:right"></Page>
                    </Col>
                </Row>

                <!-- 模态框insert -->
                <Modal v-model="isShowInsertModal" :mask-closable="false" width="680">
                    <p slot="header" style="color:#19be6b;text-align:center">
                        <Icon type="md-create" />
                        <span>阶梯气价</span>
                    </p>
                    <Form ref="formInsert" :label-width="110" :rules="ruleInsert" :model="formInsert">
                        <FormItem prop="ladderPriceName" label="阶梯气价名称：">
                            <Input v-model="formInsert.ladderPriceName" placeholder="请输入阶梯气价名称..."></Input>
                        </FormItem>
                        <FormItem prop="gasType" label="用气类型：">
                            <Select v-model="formInsert.gasType" placeholder="请选择用气类型...">
                                <Option v-for="(value,key) in ladderPriceGasType" :value="key" :key="key">{{value}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem prop="ladderGoverningId" label="管辖机构：">
                            <Select v-model="formInsert.ladderGoverningId" placeholder="请选择管辖机构...">
                                <Option v-for="value in governingBodyList" :value="value.governingBodyId" :key="value.governingBodyId">
                                    {{value.governingBodyName}}</Option>
                            </Select>
                        </FormItem>
                        <Row>
                            <Col span=12>
                                <FormItem> 主阶梯气价 </FormItem>
                                <FormItem prop="ladderStartDate" label="开始时间：">
                                    <DatePicker :transfer="true" :editable="false" v-model="formInsert.ladderStartDate" type="date" split-panels
                                        placeholder="请输入开始时间..." style="width:212px;" :clearable="false" />
                                </FormItem>
                                <FormItem prop="ladderEndDate" label="结束时间：">
                                    <DatePicker :transfer="true" :editable="false" v-model="formInsert.ladderEndDate" type="date" split-panels
                                        placeholder="请输入结束时间..." style="width:212px;" :clearable="false" />
                                </FormItem>
                                <FormItem prop="ladderSettleType" label="结算类型：">
                                    <Select v-model="formInsert.ladderSettleType" placeholder="请选择结算类型...">
                                        <Option v-for="(value,key) in ladderPriceSettleTypeList" :value="key" :key="key">{{value}}</Option>
                                    </Select>
                                </FormItem>
                                <FormItem prop="ladderSettleDays" label="结算周期：">
                                    <InputNumber v-model="formInsert.ladderSettleDays" :max="10000" :min="1" :step="1"
                                        :precision="0" style="width:212px;"></InputNumber>
                                </FormItem>
                                <FormItem prop="ladderData" label="阶梯数据：">
                                    <Row v-for="item in ladderDataList" :key="item" span=24>
                                        <Col span=12>
                                        <Span>第{{item + 1}}阶梯气量：</Span>
                                        </Col>
                                        <Col span=12>
                                        <InputNumber v-if="item<5" v-model="formInsert.ladderDataFlow[item]" :max="65535" :min="1"
                                            :step="1" :precision="0" style="width:107px;" @on-blur="setFlowZero(item)"></InputNumber>
                                        <InputNumber v-if="item==5" v-model="formInsert.ladderDataFlow[item]" :max="65535" :min="65535"
                                            :step="1" :precision="0" style="width:107px;" @on-blur="setFlowZero(item)"></InputNumber>
                                        </Col>
                                        <Col span=12>
                                        <Span>第{{item + 1}}阶梯气价：</Span>
                                        </Col>
                                        <Col span=12>
                                        <InputNumber v-model="formInsert.ladderDataPrice[item]" :max="655" :min="0" :step="1"
                                            :precision="2" style="width:107px;" @on-blur="setPriceZero(item)"></InputNumber>
                                        </Col>
                                    </Row>
                                    <Button :disabled="ladderDataDisabled" long @click="addLadderDataList">添加阶梯</Button>
                                    <Button long @click="deleteLadderDataList">删除阶梯</Button>
                                </FormItem>
                            </Col>
                            <Col span=12>
                                <FormItem> 备用阶梯气价 </FormItem>
                                <FormItem prop="standbyladderStartDate" label="开始时间：">
                                    <DatePicker :transfer="true" :editable="false" v-model="formInsert.standbyladderStartDate" type="date" split-panels
                                        placeholder="请输入开始时间..." style="width:212px;" :clearable="false" />
                                </FormItem>
                                <FormItem prop="standbyladderEndDate" label="结束时间：">
                                    <DatePicker :transfer="true" :editable="false" v-model="formInsert.standbyladderEndDate" type="date" split-panels
                                        placeholder="请输入结束时间..." style="width:212px;" :clearable="false" />
                                </FormItem>
                                <FormItem prop="standbyladderSettleType" label="结算类型：">
                                    <Select v-model="formInsert.standbyladderSettleType" placeholder="请选择结算类型...">
                                        <Option v-for="(value,key) in ladderPriceSettleTypeList" :value="key" :key="key">{{value}}</Option>
                                    </Select>
                                </FormItem>
                                <FormItem prop="standbyladderSettleDays" label="结算周期：">
                                    <InputNumber v-model="formInsert.standbyladderSettleDays" :max="10000" :min="1" :step="1"
                                        :precision="0" style="width:212px;"></InputNumber>
                                </FormItem>
                                <FormItem prop="standbyladderData" label="阶梯数据：">
                                    <Row v-for="item in standbyladderDataList" :key="item" span=24>
                                        <Col span=12>
                                        <Span>第{{item + 1}}阶梯气量：</Span>
                                        </Col>
                                        <Col span=12>
                                        <InputNumber v-if="item<5" v-model="formInsert.standbyladderDataFlow[item]" :max="65535" :min="1"
                                            :step="1" :precision="0" style="width:107px;" @on-blur="setFlowZero(item)"></InputNumber>
                                        <InputNumber v-if="item==5" v-model="formInsert.standbyladderDataFlow[item]" :max="65535" :min="65535"
                                            :step="1" :precision="0" style="width:107px;" @on-blur="setFlowZero(item)"></InputNumber>
                                        </Col>
                                        <Col span=12>
                                        <Span>第{{item + 1}}阶梯气价：</Span>
                                        </Col>
                                        <Col span=12>
                                        <InputNumber v-model="formInsert.standbyladderDataPrice[item]" :max="655" :min="0" :step="1"
                                            :precision="2" style="width:107px;" @on-blur="setPriceZero(item)"></InputNumber>
                                        </Col>
                                    </Row>
                                    <Button :disabled="standbyladderDataDisabled" long @click="addstandbyLadderDataList">添加阶梯</Button>
                                    <Button long @click="deletestandbyLadderDataList">删除阶梯</Button>
                                </FormItem>
                            </Col>
                        </Row>
                    </Form>
                    <div slot="footer">
                        <Button type="success" size="large" long :loading="isLoadingButton" @click="commitInsert">添加</Button>
                    </div>
                </Modal>

                <!-- 模态框update -->
                <Modal v-model="isShowUpdateModal" :mask-closable="false" width="680">
                    <p slot="header" style="color:#ff9900;text-align:center">
                        <Icon type="md-create" />
                        <span>阶梯气价</span>
                    </p>
                    <Form ref="formUpdate" :label-width="110" :rules="ruleUpdate" :model="formUpdate">
                        <FormItem prop="ladderPriceName" label="阶梯气价名称：">
                            <Input v-model="formUpdate.ladderPriceName" placeholder="请输入阶梯气价名称..."></Input>
                        </FormItem>
                        <FormItem prop="gasType" label="用气类型：">
                            <Select v-model="formUpdate.gasType" placeholder="请选择用气类型...">
                                <Option v-for="(value,key) in ladderPriceGasType" :value="key" :key="key">{{value}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem prop="ladderGoverningId" label="管辖机构：">
                            <Select v-model="formUpdate.ladderGoverningId" placeholder="请选择管辖机构...">
                                <Option v-for="value in governingBodyList" :value="value.governingBodyId" :key="value.governingBodyId">
                                    {{value.governingBodyName}}</Option>
                            </Select>
                        </FormItem>
                        <Row>
                            <Col span=12>
                                <FormItem> 主阶梯气价 </FormItem>
                                <FormItem prop="ladderStartDate" label="开始时间：">
                                    <DatePicker :transfer="true" v-model="formUpdate.ladderStartDate" type="date" split-panels
                                        placeholder="请输入开始时间..." style="width:212px;" :clearable="false" />
                                </FormItem>
                                <FormItem prop="ladderEndDate" label="结束时间：">
                                    <DatePicker :transfer="true" v-model="formUpdate.ladderEndDate" type="date" split-panels
                                        placeholder="请输入结束时间..." style="width:212px;" :clearable="false" />
                                </FormItem>
                                <FormItem prop="ladderSettleType" label="结算类型：">
                                    <Select v-model="formUpdate.ladderSettleType" placeholder="请选择结算类型...">
                                        <Option v-for="(value,key) in ladderPriceSettleTypeList" :value="key" :key="key">{{value}}</Option>
                                    </Select>
                                </FormItem>
                                <FormItem prop="ladderSettleDays" label="结算周期：">
                                    <InputNumber v-model="formUpdate.ladderSettleDays" :max="10000" :min="1" :step="1"
                                        :precision="0" style="width:212px;"></InputNumber>
                                </FormItem>
                                
                                <FormItem prop="ladderData" label="阶梯数据：">
                                    <Row v-for="item in ladderDataUpdateList" :key="item" span=24>
                                        <Col span=12>
                                        <Span>第{{item + 1}}阶梯气量：</Span>
                                        </Col>
                                        <Col span=12>
                                        <InputNumber v-if="item<5" v-model="formUpdate.ladderDataFlow[item]" :max="65535" :min="1"
                                            :step="1" :precision="0" style="width:107px;" @on-blur="setFlowZero(item)"></InputNumber>
                                        <InputNumber v-if="item==5" v-model="formUpdate.ladderDataFlow[item]" :max="65535" :min="65535"
                                            :step="1" :precision="0" style="width:107px;" @on-blur="setFlowZero(item)"></InputNumber>
                                        </Col>
                                        <Col span=12>
                                        <Span>第{{item + 1}}阶梯气价：</Span>
                                        </Col>
                                        <Col span=12>
                                        <InputNumber v-model="formUpdate.ladderDataPrice[item]" :max="655" :min="0" :step="1"
                                            :precision="2" style="width:107px;" @on-blur="setPriceZero(item)"></InputNumber>
                                        </Col>
                                    </Row>
                                </FormItem>
                            </Col>
                            <Col span=12>
                                <FormItem> 备用阶梯气价 </FormItem>
                                <FormItem prop="standbyladderStartDate" label="开始时间：">
                                    <DatePicker :transfer="true" v-model="formUpdate.standbyladderStartDate" type="date" split-panels
                                        placeholder="请输入开始时间..." style="width:212px;" :clearable="false" />
                                </FormItem>
                                <FormItem prop="standbyladderEndDate" label="结束时间：">
                                    <DatePicker :transfer="true" v-model="formUpdate.standbyladderEndDate" type="date" split-panels
                                        placeholder="请输入结束时间..." style="width:212px;" :clearable="false" />
                                </FormItem>
                                <FormItem prop="standbyladderSettleType" label="结算类型：">
                                    <Select v-model="formUpdate.standbyladderSettleType" placeholder="请选择结算类型...">
                                        <Option v-for="(value,key) in ladderPriceSettleTypeList" :value="key" :key="key">{{value}}</Option>
                                    </Select>
                                </FormItem>
                                <FormItem prop="standbyladderSettleDays" label="结算周期：">
                                    <InputNumber v-model="formUpdate.standbyladderSettleDays" :max="10000" :min="1" :step="1"
                                        :precision="0" style="width:212px;"></InputNumber>
                                </FormItem>
                                
                                <FormItem prop="ladderData" label="阶梯数据：">
                                    <Row v-for="item in standbyladderDataUpdateList" :key="item" span=24>
                                        <Col span=12>
                                        <Span>第{{item + 1}}阶梯气量：</Span>
                                        </Col>
                                        <Col span=12>
                                        <InputNumber v-if="item<5" v-model="formUpdate.standbyladderDataFlow[item]" :max="65535" :min="1"
                                            :step="1" :precision="0" style="width:107px;" @on-blur="setFlowZero(item)"></InputNumber>
                                        <InputNumber v-if="item==5" v-model="formUpdate.standbyladderDataFlow[item]" :max="65535" :min="65535"
                                            :step="1" :precision="0" style="width:107px;" @on-blur="setFlowZero(item)"></InputNumber>
                                        </Col>
                                        <Col span=12>
                                        <Span>第{{item + 1}}阶梯气价：</Span>
                                        </Col>
                                        <Col span=12>
                                        <InputNumber v-model="formUpdate.standbyladderDataPrice[item]" :max="655" :min="0" :step="1"
                                            :precision="2" style="width:107px;" @on-blur="setPriceZero(item)"></InputNumber>
                                        </Col>
                                    </Row>
                                </FormItem>
                            </Col>
                        </Row>
                        
                    </Form>
                    <div slot="footer">
                        <Button type="warning" size="large" long :loading="isLoadingButton" @click="commitUpdate">修改</Button>
                    </div>
                </Modal>

                <!-- 模态框delete -->
                <Modal v-model="isShowDeleteModal" :mask-closable="false" width="380">
                    <p slot="header" style="color:#ed4014;text-align:center">
                        <Icon type="md-create" />
                        <span>阶梯气价</span>
                    </p>
                    <div style="color:#ed4014;text-align:center">
                        是否确认删除所选数据？
                    </div>
                    <div slot="footer">
                        <Button type="error" size="large" long :loading="isLoadingButton" @click="commitDelete">删除</Button>
                    </div>
                </Modal>
            </TabPane>
        </Tabs>
    </div>
</template>

<script>
    export default {
        mounted() {
            this.getShowData();
            this.request();
        },
        data() {
            const validateDate = (rule, value, callback) => {
                if (value.length === 0) {
                    callback(new Error(''));
                } else {
                    callback();
                }
            };
            const validateNumber = (rule, value, callback) => {
                if (value === null) {
                    callback(new Error(''));
                } else {
                    callback();
                }
            };
            const validateInsertLadder = (rule, value, callback) => {
                if (this.formInsert.ladderDataFlow.length === 0 ||
                    this.formInsert.ladderDataFlow[0] === 0) {
                    callback(new Error(''));
                } else {
                    callback();
                }
            };
            const validateUpdateLadder = (rule, value, callback) => {
                if (this.formUpdate.ladderDataFlow.length === 0 ||
                    this.formUpdate.ladderDataFlow[0] === 0) {
                    callback(new Error(''));
                } else {
                    callback();
                }
            };
            return {
                height: window.innerHeight,
                isSpinShow: false,
                isLoadingButton: false,
                isShowInsertModal: false,
                isShowUpdateModal: false,
                isShowDeleteModal: false,
                isShowTarget: false,
                isSpinShow: false,
                currentPage: 1,
                dataCount: 0,
                pageSize: 10,
                selectedRow: null,
                ladderDataList: [],
                standbyladderDataList: [],
                ladderDataUpdateList: [],
                standbyladderDataUpdateList: [],
                ladderDataDisabled: false,
                standbyladderDataDisabled: false,
                ladderDataUpdateDisabled: false,
                ladderPriceSettleTypeList: global.ladderPriceSettleType,
                ladderPriceGasType: global.gasType,
                governingBodyList: [],
                showData: [],
                showColumns: [{
                        title: "阶梯气价id",
                        key: "ladderPriceId",
                        width: 100
                    },
                    {
                        title: "阶梯气价名称",
                        key: "ladderPriceName",
                    },
                    {
                        title: "用气类型",
                        key: "gasTypeName"
                    },
                    {
                        title: "管辖机构",
                        key: "governingBodyName"
                    },
                    {
                        title: "主阶梯气价",
                        key: "mainPlan",
                        tooltip: true
                    },
                    {
                        title: "备用阶梯气价",
                        key: "standbyPlan",
                        tooltip: true
                    }
                ],
                formInsert: {
                    ladderPriceName: "",
                    gasType: "",
                    ladderGoverningId: null,
                    ladderStartDate: null,
                    ladderEndDate: null,
                    ladderSettleType: '0',
                    ladderSettleDays: 1,
                    ladderDataFlow: [],
                    ladderDataPrice: [],
                    standbyladderStartDate: null,
                    standbyladderEndDate: null,
                    standbyladderSettleType: '0',
                    standbyladderSettleDays: 1,
                    standbyladderDataFlow: [],
                    standbyladderDataPrice: []
                },
                formUpdate: {
                    ladderPriceName: "",
                    gasType: "",
                    ladderGoverningId: null,
                    ladderStartDate: null,
                    ladderEndDate: null,
                    ladderSettleType: '0',
                    ladderSettleDays: 0,
                    ladderDataFlow: [],
                    ladderDataPrice: [],
                    standbyladderStartDate: null,
                    standbyladderEndDate: null,
                    standbyladderSettleType: '0',
                    standbyladderSettleDays: 1,
                    standbyladderDataFlow: [],
                    standbyladderDataPrice: []
                },
                ruleInsert: {
                    ladderPriceName: [{
                        required: true,
                        message: '请输入阶梯气价名称...',
                        trigger: 'change'
                    }],
                    gasType: [{
                        required: true,
                        message: '请选择用气类型...',
                        trigger: 'change'
                    }],
                    ladderGoverningId: [{
                        required: true,
                        validator: validateNumber,
                        message: '请选择管辖机构...',
                        trigger: 'change'
                    }],
                    ladderStartDate: [{
                        required: true,
                        validator: validateDate,
                        message: '请选择开始时间...',
                        trigger: 'change'
                    }],
                    ladderEndDate: [{
                        required: true,
                        validator: validateDate,
                        message: '请选择结束时间...',
                        trigger: 'change'
                    }],
                    ladderSettleType: [{
                        required: true,
                        message: '请选择结算类型...',
                        trigger: 'change'
                    }],
                    ladderSettleDays: [{
                        required: true,
                        validator: validateNumber,
                        message: '请输入结算周期...',
                        trigger: 'change'
                    }],
                    ladderData: [{
                        required: true,
                        validator: validateInsertLadder,
                        message: '至少设置一个阶梯...'
                    }],
                    standbyladderStartDate: [{
                        required: true,
                        validator: validateDate,
                        message: '请选择开始时间...',
                        trigger: 'change'
                    }],
                    standbyladderEndDate: [{
                        required: true,
                        validator: validateDate,
                        message: '请选择结束时间...',
                        trigger: 'change'
                    }],
                    standbyladderSettleType: [{
                        required: true,
                        message: '请选择结算类型...',
                        trigger: 'change'
                    }],
                    standbyladderSettleDays: [{
                        required: true,
                        validator: validateNumber,
                        message: '请输入结算周期...',
                        trigger: 'change'
                    }],
                    standbyladderData: [{
                        required: true,
                        validator: validateInsertLadder,
                        message: '至少设置一个阶梯...'
                    }]
                },
                ruleUpdate: {
                    ladderPriceName: [{
                        required: true,
                        message: '请输入阶梯气价名称...',
                        trigger: 'change'
                    }],
                    gasType: [{
                        required: true,
                        message: '请选择用气类型...',
                        trigger: 'change'
                    }],
                    ladderGoverningId: [{
                        required: true,
                        validator: validateNumber,
                        message: '请选择管辖机构...',
                        trigger: 'change'
                    }],
                    ladderStartDate: [{
                        required: true,
                        validator: validateDate,
                        message: '请选择开始时间...',
                        trigger: 'change'
                    }],
                    ladderEndDate: [{
                        required: true,
                        validator: validateDate,
                        message: '请选择结束时间...',
                        trigger: 'change'
                    }],
                    ladderSettleType: [{
                        required: true,
                        message: '请选择结算类型...',
                        trigger: 'change'
                    }],
                    ladderSettleDays: [{
                        required: true,
                        validator: validateNumber,
                        message: '请输入结算周期...',
                        trigger: 'change'
                    }],
                    ladderData: [{
                        required: true,
                        validator: validateUpdateLadder,
                        message: '至少设置一个阶梯...'
                    }],
                    standbyladderStartDate: [{
                        required: true,
                        validator: validateDate,
                        message: '请选择开始时间...',
                        trigger: 'change'
                    }],
                    standbyladderEndDate: [{
                        required: true,
                        validator: validateDate,
                        message: '请选择结束时间...',
                        trigger: 'change'
                    }],
                    standbyladderSettleType: [{
                        required: true,
                        message: '请选择结算类型...',
                        trigger: 'change'
                    }],
                    standbyladderSettleDays: [{
                        required: true,
                        validator: validateNumber,
                        message: '请输入结算周期...',
                        trigger: 'change'
                    }],
                    standbyladderData: [{
                        required: true,
                        validator: validateInsertLadder,
                        message: '至少设置一个阶梯...'
                    }]
                }
            }
        },
        methods: {
            request() {
                let that = this;
                $.ajax({
                    url: "/api/info/governingBodyList",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify({}),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.governingBodyList = data.body;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });
            },
            getShowData() {
                var that = this;
                that.isSpinShow = true;
                that.selectedRow = null;
                $.ajax({
                    url: "/api/ladderPrice/selectLadderPriceGasType?page=" +
                        that.currentPage +
                        "&pageAmount=" +
                        that.pageSize,
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify({}),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.showData = data.body.resultList.map(param => {
                            param["ladderData"] = JSON.parse(param.ladderDataString) || {};
                            let mainPlan = "";
                            mainPlan += "开始时间：" + global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(
                                param.ladderData.mainPlanStartTime)) + "\n";
                            mainPlan += "结束时间：" + global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(
                                param.ladderData.mainPlanEndTime)) + "\n";
                            mainPlan += "结算类型：" + global.ladderPriceSettleType[param.ladderData.mainPlanSettleType];
                            if (param.ladderData.mainPlanSettleType != 0 && param.ladderData.mainPlanSettleType != 4) {
                                mainPlan += "\n结算周期：" + param.ladderData.mainPlanSettleParameter;
                            }
                            for (var i = 1; i <= 6; i++) {
                                mainPlan += "\n" + "第" + i + "阶梯共" + param.ladderData["mainPlanLadder" + i +
                                    "Flow"] + "m³,价格:" + param.ladderData["mainPlanLadder" + i +
                                    "Price"] / 100 + "元/m³";
                            }
                            param["mainPlan"] = mainPlan;
                            let standbyPlan = "";
                            standbyPlan += "开始时间：" + global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(
                                param.ladderData.standbyPlanStartTime)) + "\n";
                            standbyPlan += "结束时间：" + global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(
                                param.ladderData.standbyPlanEndTime)) + "\n";
                            standbyPlan += "结算类型：" + global.ladderPriceSettleType[param.ladderData.standbyPlanSettleType];
                            if (param.ladderData.standbyPlanSettleType != 0 && param.ladderData.standbyPlanSettleType != 4) {
                                standbyPlan += "\n结算周期：" + param.ladderData.standbyPlanSettleParameter;
                            }
                            for (var i = 1; i <= 6; i++) {
                                standbyPlan += "\n" + "第" + i + "阶梯共" + param.ladderData["standbyPlanLadder" + i +
                                    "Flow"] + "m³,价格:" + param.ladderData["standbyPlanLadder" + i +
                                    "Price"] / 100 + "元/m³";
                            }
                            param["standbyPlan"] = standbyPlan;
                            return param;
                        });
                        console.log(that.showData);
                        that.dataCount = data.body.amount;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    },
                    complete: function(){
                        that.isSpinShow = false;
                    }
                });
            },
            changePage(index) {
                this.currentPage = index;
                this.getShowData();
            },
            changePageSize(size) {
                this.pageSize = size;
                this.getShowData();
            },
            onSelectionTableChange(currentRow) {
                this.selectedRow = currentRow;
            },
            onClickInsert() {
                this.isShowInsertModal = true;
            },
            onClickUpdate() {
                if (this.selectedRow != null) {
                    this.formUpdate["ladderPriceId"] = this.selectedRow.ladderPriceId;
                    this.formUpdate.ladderPriceName = this.selectedRow.ladderPriceName;
                    this.formUpdate.gasType = "" + this.selectedRow.gasTypeId;
                    this.formUpdate.ladderGoverningId = this.selectedRow.governingBodyId;
                    let ladderDataJSONObject = JSON.parse(this.selectedRow.ladderDataString) || {};
                    this.formUpdate.ladderStartDate = ladderDataJSONObject.mainPlanStartTime;
                    this.formUpdate.ladderEndDate = ladderDataJSONObject.mainPlanEndTime;
                    this.formUpdate.ladderSettleType = ladderDataJSONObject.mainPlanSettleType;
                    this.formUpdate.ladderSettleDays = ladderDataJSONObject.mainPlanSettleParameter;
                    this.formUpdate.ladderDataFlow = [];
                    this.formUpdate.ladderDataPrice = [];
                    this.ladderDataUpdateList = [];
                    for(let i = 1; i <= 6; i++){
                        this.formUpdate.ladderDataFlow.push(ladderDataJSONObject["mainPlanLadder"+i+"Flow"]);
                        this.formUpdate.ladderDataPrice.push(ladderDataJSONObject["mainPlanLadder"+i+"Price"] / 100);
                        this.ladderDataUpdateList.push(i-1);
                    }
                    this.formUpdate.standbyladderStartDate = ladderDataJSONObject.standbyPlanStartTime;
                    this.formUpdate.standbyladderEndDate = ladderDataJSONObject.standbyPlanEndTime;
                    this.formUpdate.standbyladderSettleType = ladderDataJSONObject.standbyPlanSettleType;
                    this.formUpdate.standbyladderSettleDays = ladderDataJSONObject.standbyPlanSettleParameter;
                    this.formUpdate.standbyladderDataFlow = [];
                    this.formUpdate.standbyladderDataPrice = [];
                    this.standbyladderDataUpdateList = [];
                    for(let i = 1; i <= 6; i++){
                        this.formUpdate.standbyladderDataFlow.push(ladderDataJSONObject["standbyPlanLadder"+i+"Flow"]);
                        this.formUpdate.standbyladderDataPrice.push(ladderDataJSONObject["standbyPlanLadder"+i+"Price"] / 100);
                        this.standbyladderDataUpdateList.push(i-1);
                    }
                    this.isShowUpdateModal = true;
                } else {
                    this.$Notice.error({
                        title: "警告",
                        desc: "请选择一条数据！"
                    });
                }
            },
            onClickDelete() {
                if (this.selectedRow != null) {
                    this.isShowDeleteModal = true;
                } else {
                    this.$Notice.error({
                        title: "警告",
                        desc: "请选择一条数据！"
                    });
                }
            },
            commitInsert() {
                let that = this;
                that.$refs['formInsert'].validate((valid) => {
                    if (valid) {
                        that.isLoadingButton = true;
                        
                        let sendObject = {};
                        sendObject.ladderPriceName = that.formInsert.ladderPriceName;
                        sendObject.gasType = that.formInsert.gasType;
                        sendObject.ladderGoverningId = that.formInsert.ladderGoverningId;
                        let ladderDataJSONObject = {};
                        ladderDataJSONObject.mainPlanStartTime = global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(that.formInsert.ladderStartDate));
                        ladderDataJSONObject.mainPlanEndTime = global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(that.formInsert.ladderEndDate));
                        ladderDataJSONObject.mainPlanSettleType = that.formInsert.ladderSettleType;
                        ladderDataJSONObject.mainPlanSettleParameter = that.formInsert.ladderSettleDays;
                        for(let i = 1; i <= that.formInsert.ladderDataFlow.length; i++){
                            ladderDataJSONObject["mainPlanLadder" + i + "Flow"] = that.formInsert.ladderDataFlow[i-1];
                            ladderDataJSONObject["mainPlanLadder" + i + "Price"] = that.formInsert.ladderDataPrice[i-1] * 100;
                        }
                        for (let i = that.formInsert.ladderDataFlow.length + 1; i <= 6; i++) {
                            ladderDataJSONObject["mainPlanLadder" + i + "Flow"] = 65535;
                            ladderDataJSONObject["mainPlanLadder" + i + "Price"] = ladderDataJSONObject["mainPlanLadder" + that.formInsert.ladderDataFlow.length + "Price"];
                        }
                        ladderDataJSONObject.standbyPlanStartTime = global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(that.formInsert.standbyladderStartDate));
                        ladderDataJSONObject.standbyPlanEndTime = global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(that.formInsert.standbyladderEndDate));
                        ladderDataJSONObject.standbyPlanSettleType = that.formInsert.standbyladderSettleType;
                        ladderDataJSONObject.standbyPlanSettleParameter = that.formInsert.standbyladderSettleDays;
                        for(let i = 1; i <= that.formInsert.standbyladderDataFlow.length; i++){
                            ladderDataJSONObject["standbyPlanLadder" + i + "Flow"] = that.formInsert.standbyladderDataFlow[i-1];
                            ladderDataJSONObject["standbyPlanLadder" + i + "Price"] = that.formInsert.standbyladderDataPrice[i-1] * 100;
                        }
                        for (let i = that.formInsert.standbyladderDataFlow.length + 1; i <= 6; i++) {
                            ladderDataJSONObject["standbyPlanLadder" + i + "Flow"] = 65535;
                            ladderDataJSONObject["standbyPlanLadder" + i + "Price"] = ladderDataJSONObject["standbyPlanLadder" + that.formInsert.standbyladderDataFlow.length + "Price"];
                        }
                        sendObject.ladderDataString = JSON.stringify(ladderDataJSONObject);
                        $.ajax({
                            url: "/api/ladderPrice/insert",
                            contentType: "application/json",
                            type: "post",
                            data: JSON.stringify(sendObject),
                            dataType: "json",
                            success: function(data) {
                                if (data.errorCode != 0) {
                                    that.$Notice.error({
                                        title: "异常",
                                        desc: data.errorInfo
                                    });
                                    return;
                                }
                                that.isShowInsertModal = false;
                                that.getShowData();
                                that.isLoadingButton = false;
                            },
                            error: function(textStatus) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: "接口请求异常"
                                });
                                that.isLoadingButton = false;
                            }
                        });
                    }else{
                        console.log(that.formInsert);
                    }
                });
            },
            commitUpdate() {
                let that = this;
                that.$refs['formUpdate'].validate((valid) => {
                    if (valid) {
                        that.isLoadingButton = true;
                        let sendObject = {};
                        sendObject.ladderPriceId = that.formUpdate.ladderPriceId;
                        sendObject.ladderPriceName = that.formUpdate.ladderPriceName;
                        sendObject.gasType = that.formUpdate.gasType;
                        sendObject.ladderGoverningId = that.formUpdate.ladderGoverningId;
                        let ladderDataJSONObject = {};
                        ladderDataJSONObject.mainPlanStartTime = global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(that.formUpdate.ladderStartDate));
                        ladderDataJSONObject.mainPlanEndTime = global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(that.formUpdate.ladderEndDate));
                        ladderDataJSONObject.mainPlanSettleType = that.formUpdate.ladderSettleType;
                        ladderDataJSONObject.mainPlanSettleParameter = that.formUpdate.ladderSettleDays;
                        for(let i = 1; i <= that.formUpdate.ladderDataFlow.length; i++){
                            ladderDataJSONObject["mainPlanLadder" + i + "Flow"] = that.formUpdate.ladderDataFlow[i-1];
                            ladderDataJSONObject["mainPlanLadder" + i + "Price"] = that.formUpdate.ladderDataPrice[i-1] * 100;
                        }
                        for (let i = that.formUpdate.ladderDataFlow.length + 1; i <= 6; i++) {
                            ladderDataJSONObject["mainPlanLadder" + i + "Flow"] = 65535;
                            ladderDataJSONObject["mainPlanLadder" + i + "Price"] = ladderDataJSONObject["mainPlanLadder" + that.formUpdate.ladderDataFlow.length + "Price"];
                        }
                        ladderDataJSONObject.standbyPlanStartTime = global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(that.formUpdate.standbyladderStartDate));
                        ladderDataJSONObject.standbyPlanEndTime = global.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(that.formUpdate.standbyladderEndDate));
                        ladderDataJSONObject.standbyPlanSettleType = that.formUpdate.standbyladderSettleType;
                        ladderDataJSONObject.standbyPlanSettleParameter = that.formUpdate.standbyladderSettleDays;
                        for(let i = 1; i <= that.formUpdate.standbyladderDataFlow.length; i++){
                            ladderDataJSONObject["standbyPlanLadder" + i + "Flow"] = that.formUpdate.standbyladderDataFlow[i-1];
                            ladderDataJSONObject["standbyPlanLadder" + i + "Price"] = that.formUpdate.standbyladderDataPrice[i-1] * 100;
                        }
                        for (let i = that.formUpdate.standbyladderDataFlow.length + 1; i <= 6; i++) {
                            ladderDataJSONObject["standbyPlanLadder" + i + "Flow"] = 65535;
                            ladderDataJSONObject["standbyPlanLadder" + i + "Price"] = ladderDataJSONObject["standbyPlanLadder" + that.formUpdate.standbyladderDataFlow.length + "Price"];
                        }
                        sendObject.ladderDataString = JSON.stringify(ladderDataJSONObject);
                        $.ajax({
                            url: "/api/ladderPrice/update",
                            contentType: "application/json",
                            type: "post",
                            data: JSON.stringify(sendObject),
                            dataType: "json",
                            success: function(data) {
                                if (data.errorCode != 0) {
                                    that.$Notice.error({
                                        title: "异常",
                                        desc: data.errorInfo
                                    });
                                    return;
                                }
                                that.isShowUpdateModal = false;
                                that.getShowData();
                                that.isLoadingButton = false;
                            },
                            error: function(textStatus) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: "接口请求异常"
                                });
                                that.isLoadingButton = false;
                            }
                        });
                    }
                });
            },
            commitDelete() {
                let that = this;
                that.isLoadingButton = true;
                $.ajax({
                    url: "/api/ladderPrice/delete",
                    contentType: "application/json",
                    type: "post",
                    data: JSON.stringify({
                        ladderPriceId: that.selectedRow.ladderPriceId
                    }),
                    dataType: "json",
                    success: function(data) {
                        if (data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            return;
                        }
                        that.isShowDeleteModal = false;
                        that.getShowData();
                        that.isLoadingButton = false;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                        that.isLoadingButton = false;
                    }
                });
            },
            addLadderDataList() {
                if (this.ladderDataList.length == 5) {
                    this.ladderDataDisabled = true;
                    this.ladderDataList.push(this.ladderDataList.length);
                    this.formInsert.ladderDataFlow[this.ladderDataList.length - 1] = 65535;
                    this.formInsert.ladderDataPrice[this.ladderDataList.length - 1] = 1;
                } else {
                    this.ladderDataList.push(this.ladderDataList.length);
                    this.formInsert.ladderDataFlow[this.ladderDataList.length - 1] = 1;
                    this.formInsert.ladderDataPrice[this.ladderDataList.length - 1] = 1;
                }
            },
            deleteLadderDataList() {
                if (this.ladderDataList.length > 0) {
                    this.ladderDataList.pop();
                    this.formInsert.ladderDataFlow.pop();
                    this.formInsert.ladderDataPrice.pop();
                }
            },
            addstandbyLadderDataList() {
                if (this.standbyladderDataList.length == 5) {
                    this.standbyladderDataDisabled = true;
                    this.standbyladderDataList.push(this.standbyladderDataList.length);
                    this.formInsert.standbyladderDataFlow[this.standbyladderDataList.length - 1] = 65535;
                    this.formInsert.standbyladderDataPrice[this.standbyladderDataList.length - 1] = 1;
                } else {
                    this.standbyladderDataList.push(this.standbyladderDataList.length);
                    this.formInsert.standbyladderDataFlow[this.standbyladderDataList.length - 1] = 1;
                    this.formInsert.standbyladderDataPrice[this.standbyladderDataList.length - 1] = 1;
                }
            },
            deletestandbyLadderDataList() {
                if (this.standbyladderDataList.length > 0) {
                    this.standbyladderDataList.pop();
                    this.formInsert.standbyladderDataFlow.pop();
                    this.formInsert.standbyladderDataPrice.pop();
                }
            },
            addLadderDataUpdateList() {
                if (this.ladderDataUpdateList.length == 5) {
                    this.ladderDataUpdateDisabled = true;
                }
                this.ladderDataUpdateList.push(this.ladderDataUpdateList.length);
                this.formUpdate.ladderDataFlow[this.ladderDataUpdateList.length - 1] = 1;
                this.formUpdate.ladderDataPrice[this.ladderDataUpdateList.length - 1] = 1;
            },
            setFlowZero(param) {
                if (this.formInsert.ladderDataFlow[param] == null) {
                    this.formInsert.ladderDataFlow[param] = 0;
                }
            },
            setPriceZero(param) {
                if (this.formInsert.ladderDataPrice[param] == null) {
                    this.formInsert.ladderDataPrice[param] = 0;
                }
            }
        }
    }
</script>

<style>
</style>
